<template>
  <div id="MediaManager">
    <el-button
      v-if="showBtn"
      class="open"
      type="warning"
      @click="dialogVisible = true"
      icon="el-icon-picture"
      circle
    ></el-button>

    <el-dialog
      :title="'素材管理 - 选择数量：'+multiple"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="850px"
      :fullscreen="false"
    >
    <!-- v-loading="loading"
      element-loading-text="处理中..." -->
      <!-- {{list}}
          <hr/>
         {{listSelect}}
         <hr/>
      {{selectIndex}}-->
      <div class="filelist">

        <el-row>
      <el-col :span="12"><div>
        <el-upload
          action
          accept=".jpg,.png,.gif"
          :show-file-list="false"
          :http-request="upload"
          :before-upload="beforeUpload"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2mb</div>
        </el-upload>
        </div></el-col>
      <el-col :span="12"><div>
        <el-progress
          v-if="progress>=0"
          :text-inside="true"
          :stroke-width="15"
          :percentage="progress"
        ></el-progress>
        </div></el-col>
    </el-row>

        
        <br>
        


          <el-card :body-style="{ padding: '0px' }" style="float:left;margin: 5px;" v-for="item in list" v-bind:key="item.id">
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.name"
              placement="top"
              @click="onSelect(item)"
            >
              <i v-if="item.type==='mp4'" class="el-icon-video-camera avatar-uploader-icon" style="width: 150px;height: 150px;font-size: 80px;line-height: 150px;background-color: antiquewhite;"></i>
              <el-image v-else style="width: 150px; height: 150px" :src="oss.base+oss.prefix+item.url" fit="cover"></el-image>
            </el-tooltip>
            <div style="padding: 0 14px; text-align: right;">
              <div class="bottom clearfix">
                <el-button
                  type="text"
                  class="button"
                  @click="onSelect(item)"
                >{{(item.select && multiple>1)?item.select:''}} {{item.select?'取消选择':'选择'}}</el-button>
                <el-button type="text" class="button" @click="onDel(item)">删除</el-button>
              </div>
            </div>
          </el-card>

        <el-alert
          :closable="false"
          v-if="!list || list.length==0"
          title="没有图片资源，请上传"
          type="info"
          center
          show-icon
        ></el-alert>

        <div style="clear: both;">
          <br>
          <el-button v-if="multiple>1" @click="clearSelect()">全部取消</el-button>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onFinish()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { MyMessage,MyStorage,getOSS } from '@/common.js';

const OSS = require('ali-oss');

export default {
  props: ["uuid","showBtn","type","objId","date"],
  data() {
    return {
      //imgPath:this.type=="game"?process.env.VUE_APP_IMG_PATH_GAME:process.env.VUE_APP_IMG_PATH_ARTICLE,
      multiple: 1,
      progress: -1,
      loading: false,
      loaded: false,
      target: "", //返回标记
      dialogVisible: false,
      list: [],
      listSelect: [],
      selectIndex: 1,
      //basePath:'',

      oss:{
        base:process.env.VUE_APP_OSS_base,   //url
        prefix:this.type+'Img/',  //前缀
        path:''   //文件变化的路径
      }
      
    };
  },
  watch:{
    objId(){
      this.loaded=false;
      this.list=[];
      this.listSelect=[];
    }
  },
  methods: {
    getSTS(callback){
      let Expiration=localStorage.getItem('Expiration');
      if(!Expiration || (new Date()).valueOf()-Expiration>13*60*1000){
          this.api.getSTS(res=>{
              MyStorage.setItem('Expiration',(new Date()).valueOf());
              MyStorage.setItem('AccessKeySecret',res.data.AccessKeySecret);
              MyStorage.setItem('AccessKeyId',res.data.AccessKeyId);
              MyStorage.setItem('SecurityToken',res.data.SecurityToken);
              callback({
                AccessKeySecret:res.data.AccessKeySecret,
                AccessKeyId:res.data.AccessKeyId,
                SecurityToken:res.data.SecurityToken
              });
          });
      }else{
          callback({
              AccessKeySecret:MyStorage.getItem('AccessKeySecret'),
              AccessKeyId:MyStorage.getItem('AccessKeyId'),
              SecurityToken:MyStorage.getItem('SecurityToken')
          });
      }
    },
    loadData() {
      var d = new Date(this.date);
      this.oss.path=d.getFullYear()+("0"+(d.getMonth()+1)).slice(-2)+'/'+this.objId+'/';
      //this.basePath=this.imgPath+d.getFullYear()+("0"+(d.getMonth()+1)).slice(-2)+'/'+this.objId+'/';

      if (this.loaded) return;
      this.loaded = true;
      this.loading = true;
      this.api.media_list({ uuid: this.uuid }, res => {
        this.list = res.data;
        this.list.forEach(element => {
          //element.url = process.env.VUE_APP_IMG_PATH + this.type +'Img/' + element.url;
        });
        this.loading = false;
      });
    },
    open(target = "", multiple = 1) {
      this.clearSelect();
      this.listSelect = [];

      this.multiple = multiple;
      this.loadData();
      this.dialogVisible = true;
      this.target = target;
    },
    onSelect(file) {
      var result = this.listSelect.some(item => {
        if (item.id == file.id) {
          return true;
        }
      });
      if (result) {
        // 已经存在

        //this.listSelect.remove(file);
        this.listSelect.splice(file.select - 1, 1);
        file.select = false;
        // 重置序号
        this.selectIndex = 1;
        this.listSelect.forEach(element => {
          element.select = this.selectIndex++;
        });
      } else {
        // 不存在
        if (this.multiple == 1 && Object.keys(this.listSelect).length <= 1) {
          this.clearSelect();
          file.select = this.selectIndex++;
          this.listSelect.push(file);
        } else if (
          this.multiple > 1 &&
          this.multiple > Object.keys(this.listSelect).length
        ) {
          file.select = this.selectIndex++;
          this.listSelect.push(file);
        } else {
          MyMessage.error("最多选择" + this.multiple + "张图片");
          return;
        }
      }
      this.list.splice(0, 0);
    },
    onFinish() {
      if (Object.keys(this.listSelect).length > 0) {
        this.$emit("onSelect", { files: this.listSelect, target: this.target });
      } else {
        MyMessage.info("没有选择任何图片！");
      }
      this.dialogVisible = false;
    },
    clearSelect() {
      this.listSelect.forEach(element => {
        element.select = false;
      });
      this.listSelect = [];
      this.selectIndex = 1;
      this.list.splice(0, 0);
    },
    onDel(file) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          //判断删除元素是否被选中
          var result = this.listSelect.some(item => {
            if (item.id == file.id) {
              return true;
            }
          });
          if (result) {
            //被选中，先取消选择
            this.listSelect.splice(file.select - 1, 1);
            file.select = false;
            // 重置序号
            this.selectIndex = 1;
            this.listSelect.forEach(element => {
              element.select = this.selectIndex++;
            });
          }
          this.api.media_del(file.id, res => {
            for (let i = 0; i < this.list.length; i++) {
              const item = this.list[i];
              if (item.id == file.id) {
                this.list.splice(i, 1);
              }
            }

            this.loaded = false;
            //this.loadData();
            MyMessage.success("删除成功!");
            this.loading = false;
          });
        })
        .catch(() => {});
    },
    beforeUpload(file) {

      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";

      if (!isJPG && !isPNG && !isGIF && !isMP4) {
        MyMessage.error("请上传 JPG，PNG或GIF 格式的图片!");
        return false;
      }
      
     if ( (isJPG || isPNG || isGIF) && file.size / 1024 / 1024 > 2) {
        MyMessage.error("图片大小不能超过 2MB!");
        return false;
      }

      for (let i = 0; i < this.list.length; i++) {
        const element = this.list[i];
        if(element.name==file.name){
          MyMessage.error("已经存在同名文件!");
          return false;
        }
      }

      return true;
    },
    upload(data) {
      getOSS(process.env.VUE_APP_OSS_bucket_media,client=>{
          var name=data.file.name;
          this.loading=true;
          client.multipartUpload(this.oss.prefix+this.oss.path+name, data.file,{
                progress: (p)=> { //获取进度条的值
                  this.progress = p*100;
                },
              }).then((res) => {
                  this.api.fileInfoSave(
                    {
                      uuid:this.uuid,
                      url:this.oss.path+encodeURIComponent(name),
                      name:name,
                      type:this.type,
                      bucket:res.bucket
                    },
                    res => {
                      this.list.push(res.data);
                      this.loading=false;
                      this.progress = -1;
                      MyMessage.success("文件上传成功！");
                    },
                    err => {}
                  );
          }).catch((err) => {
        })
      })
    }
  }
};
</script>

<style scoped>
#MediaManager .open {
  position: absolute;
  bottom: 50px;
  right: 50px;
}
.open.is-circle {
  padding: 28px;
}
.open {
  font-size: 50px;
}

.img {
  line-height: 100px;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
}
.avatar-uploader:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
